import React from "react";
import * as NR from "./NoRedux";
import * as H from "../../hooks";

export type IconTipProps = NR.IconTipProps;

const IconTip: React.FC<IconTipProps> = ({ tipContent, children, ...props }) => {
    const lg = H.useLanguage();

    const content = React.useMemo(() => {
        let content = children || tipContent;
        if (typeof content === "string") return lg.getStaticText(content);
        else return content;
    }, [children, tipContent, lg]);

    return <NR.IconTip {...props} children={content} />;
};

export default IconTip;